import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-logout',
    template: `
  <p>Logging out...</p>
  <p>Please close this tab to complete the logout process.</p>
  `,
    standalone: false
})
export class LogoutComponent implements OnInit {

  ngOnInit() {
    sessionStorage.clear();
  }
}
